import React, { useState } from "react";
import { useSimularAceptacionMutation, useSimularLevanteMutation } from "../../libs/redux/slices/Simulab/simulabApiSlice";
import { ejecutar } from "./simulab";

/**
 * Paso 1 del simulador: la DIAN. Aceptación de las declaraciones (si aún no la tienen) y levante definitivo o especial
 * (entrega urgente), por los mismos caminos del motor de simulación (simular:aceptacion / simular:levante).
 * @param {object} props
 * @param {string} props.docnroxx DO
 * @param {Function} props.alTerminar Refresca el «Qué pasó»
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Pasolevx = ({ docnroxx, alTerminar }) => {
  const [aceptar, { isLoading: aceptando }] = useSimularAceptacionMutation();
  const [levantar, { isLoading: levantando }] = useSimularLevanteMutation();
  const [forzar, setForzar] = useState(false);
  const [salida, setSalida] = useState(null);
  const ocupado = aceptando || levantando;
  /**
   * Corre la mutación y muestra lo que respondió.
   * @param {Function} mutar Mutación
   * @param {object} extra Datos propios del botón
   */
  const correr = (mutar, extra) =>
    ejecutar(mutar, { DOCNROXX: docnroxx, FORZARXX: forzar ? "SI" : "NO", ...extra }, (d) => d.SALIDA || "Listo.", (r) => {
      setSalida(r);
      alTerminar();
    });
  return (
    <div className="rio-card sim-paso">
      <Cabepaso numero="1" titulo="Dar levante" quien="Lo hace la DIAN (y el robot Siglo XXI lo trae)" />
      <div className="sim-botones">
        <button type="button" className="sim-boton principal" disabled={ocupado} onClick={() => correr(levantar, { TIPOLEVX: "DEFINITIVO" })}>Dar levante definitivo</button>
        <button type="button" className="sim-boton" disabled={ocupado} onClick={() => correr(levantar, { TIPOLEVX: "ESPECIAL" })}>Dar levante especial</button>
        <button type="button" className="sim-boton" disabled={ocupado} onClick={() => correr(aceptar, {})}>Antes: aceptar las declaraciones</button>
      </div>
      <label className="sim-opcion">
        <input type="checkbox" checked={forzar} onChange={(e) => setForzar(e.target.checked)} /> Saltar el orden de los pasos (no recomendado)
      </label>
      <Salidasm salida={salida} />
    </div>
  );
};

/**
 * Cabeza numerada de un paso.
 * @param {object} props
 * @param {string} props.numero Número del paso
 * @param {string} props.titulo Qué se simula
 * @param {string} props.quien Quién lo hace en la vida real
 * @returns {JSX.Element}
 */
export const Cabepaso = ({ numero, titulo, quien }) => (
  <div className="sim-paso-cabeza">
    <span className="sim-numero">{numero}</span>
    <div>
      <div className="rio-card-title">{titulo}</div>
      <div className="sim-quien">{quien}</div>
    </div>
  </div>
);

/**
 * Resultado del último clic del paso.
 * @param {object} props
 * @param {{tono: string, texto: string}|null} props.salida Resultado
 * @returns {JSX.Element|null}
 */
export const Salidasm = ({ salida }) => (salida ? <div className={`sim-resultado ${salida.tono}`}>{salida.texto}</div> : null);

export default Pasolevx;
